import { Stack } from '@mantine/core'

import { Article, Category } from 'interfaces/types'

import { Categories } from '../categories'
import { SingleAdvanceItem } from '../singleAdvanceItem'

type ArticleCardListProps = {
  articles: Article[]
  categories: Category[]
  mobileLayoutStretch?: boolean
  dataTrackingCommon: any
}
const AdvanceLayout = (props: ArticleCardListProps) => {
  const {
    articles = [],
    categories = [],
    dataTrackingCommon,
    mobileLayoutStretch,
  } = props
  return (
    <Stack
      spacing={40}
      sx={{
        position: 'relative',
      }}
    >
      <SingleAdvanceItem
        mobileLayoutStretch={mobileLayoutStretch}
        articles={articles}
        dataTrackingCommon={dataTrackingCommon}
      />
      <Categories categories={categories} />
    </Stack>
  )
}

export { AdvanceLayout }
